const algoliaseaerch = require('algoliasearch')

// const client = algoliaseaerch(`TF7O4GCFGI`, `168dd1dc3f11696bc5e80fa2c1d1034b`)
const credentials = {
	appId: 'TF7O4GCFGI',
	apiKey: '168dd1dc3f11696bc5e80fa2c1d1034b',
}

module.exports = {
	credentials,
}



// WEBPACK FOOTER //
// ./secrets/algolia-key.js